import React from 'react';
import { ArrowRight, Hammer, Wrench } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../utils/mockData';

const Hero = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const scrollToContact = () => {
    document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToServices = () => {
    document.querySelector('#services')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-black via-zinc-900 to-black">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23D4AF37' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      {/* Animated Elements */}
      <div className="absolute top-20 left-10 animate-float">
        <Hammer className="h-16 w-16 text-yellow-600/20" />
      </div>
      <div className="absolute bottom-20 right-10 animate-float-delay">
        <Wrench className="h-20 w-20 text-yellow-600/20" />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 py-20 relative z-10 mt-20">
        <div className="max-w-4xl mx-auto text-center">
          {/* Logo in Hero */}
          <div className="mb-8 animate-fade-in-up flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_gr8-cabos/artifacts/1rmwygdl_612441855_1233419332106209_8852877029809590516_n.jpg"
              alt="GR8 Logo"
              className="h-32 md:h-40 w-auto drop-shadow-2xl"
            />
          </div>

          {/* Main Title */}
          <div className="mb-8 animate-fade-in-up animation-delay-200">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-4" style={{ fontFamily: 'Arial, sans-serif' }}>
              {t.hero.title}
            </h1>
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold mb-6" style={{ fontFamily: 'Arial, sans-serif' }}>
              <span className="text-yellow-600">
                {t.hero.subtitle}
              </span>
            </h2>
          </div>

          {/* Description */}
          <p className="text-xl md:text-2xl text-gray-300 mb-12 animate-fade-in-up animation-delay-400">
            {t.hero.description}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center animate-fade-in-up animation-delay-600">
            <Button 
              size="lg" 
              onClick={scrollToContact}
              className="bg-yellow-600 hover:bg-yellow-700 text-black px-8 py-6 text-lg font-bold shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200"
            >
              {t.hero.cta}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              onClick={scrollToServices}
              className="border-2 border-yellow-600 text-yellow-600 hover:bg-yellow-600 hover:text-black px-8 py-6 text-lg font-bold transition-all duration-200"
            >
              {t.hero.cta2}
            </Button>
          </div>
        </div>
      </div>

      {/* Bottom Wave */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full">
          <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,138.7C960,139,1056,117,1152,106.7C1248,96,1344,96,1392,96L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
